<template>
  <div class="main">
    <div>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="textarea"
      ></el-input>
      <el-row>
        <el-button type="primary" class="elb" @click="file_success" round
          >更新猎场</el-button
        >
      </el-row>
      <!-- <el-button type="primary" @click="update_liechang" class="elb">更新猎场</el-button> -->
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      textarea: '{"武汉":30,"深圳":100,"大连":100}'
    };
  },

  created() {},

  methods: {
    update_liechang() {
      console.log(this.textarea);
    },
    file_success(e) {
      let obj = {
        update_dict: this.textarea
      };
      require("post", "/hr24_resume/v1/mongo_resume/", obj).then(res => {
        if (!res.code) {
          this.$message({
            message: "猎场更新提交成功，请不要重复提交",
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.elb {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/user_management/update_resume.vue